import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ScriptService } from './services/script.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'angular-universal-heroku';
  constructor(private scriptService: ScriptService,
    private router: Router,
    private activatedRoute: ActivatedRoute,) {
  }


  public ngOnInit(): void {
  }
}
